<!--
  @description 发布统计
  @author xiehan
  @date 2018/12/17
-->
<template>
  <div class="releaseStatistics__content">
    <describe-block :list="list"></describe-block>
    <div :style="chartStyle" class="mt-base">
      <div class="release-chart-title" v-text="$t('releaseStatistics.title')"></div>
      <el-popover
        placement="bottom-end"
        width="450"
        trigger="click"
        v-model="timePopperVis">
        <el-button type="text" @click="queryLastWeek">{{ $t('releaseStatistics.lastWeek') }}</el-button>
        <el-button type="text" @click="queryLastMonth">{{ $t('releaseStatistics.lastMonth') }}</el-button>
        <div style="margin-top: 4px;">
          <el-date-picker 
            value-format="yyyy-MM-dd"
            style="width: 180px;" 
            v-model="startTime" 
            type="date">
          </el-date-picker>
          <span v-text="$t('alarmTrend.to')"></span>
          <el-date-picker 
            value-format="yyyy-MM-dd" 
            style="width: 180px;" 
            v-model="endTime" 
            type="date">
          </el-date-picker>
          <el-button 
            type="primary"
            @click="searchTime"
            v-text="$t('common.search')"></el-button>
        </div>
        <el-button 
          v-g-rac="gRac('releaseStatistics@confirm')"
          class="btn-position"
          slot="reference" 
          type="text" 
          @click="timePopperVis = true"
          v-text="choosenTime"></el-button>
      </el-popover>
      <chart-base 
        ref="releaseStatistics" 
        chart-id="releaseStatistics" 
        :chart-data="chartData" 
        :chart-style="chartOpt"></chart-base>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import describeBlock from '@/views/component/alarmQuery/describeBlock'
  import chartBase from '@/components/chart/chart-base.vue'
  import releaseStatisticsBiz from '@/logic/statistics/releaseStatisticsBiz'
  import TimeFormat from '@/utils/timeFormat'

  const MID_NIGHT = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
  const TOMORROW_DAY = TimeFormat.getFormatTime(MID_NIGHT + (86400 * 1000)).split(' ')[0]
  const A_WEEK_AGO = TimeFormat.getFormatTime(MID_NIGHT - (86400 * 1000 * 6)).split(' ')[0]
  const A_MONTH_AGO = TimeFormat.getFormatTime(MID_NIGHT - (86400 * 1000 * 29)).split(' ')[0]
  export default {
    mixins: [rac],
    data () {
      return {
        list: [],
        chartData: {},
        chartOpt: null,
        legendList: [this.$t('releaseStatistics.success'), this.$t('releaseStatistics.fail')],
        chartStyle: {
          width: '100%',
          height: '300px',
          position: 'relative'
        },
        startTime: A_MONTH_AGO,
        endTime: TOMORROW_DAY,
        choosenTime: this.$t('releaseStatistics.lastMonth'),
        timePopperVis: false
      }
    },
    components: {
      describeBlock,
      chartBase
    },
    methods: {
      getAllcount () {
        releaseStatisticsBiz.getAllcount().then(data => {
          this.list = [
            {num: data.allCount, title: this.$t('releaseStatistics.allCount')},
            {num: data.successCount, title: this.$t('releaseStatistics.successCount')},
            {num: data.failCount, title: this.$t('releaseStatistics.failCount')}
          ]
        })
      },
      queryLastWeek () {
        this.choosenTime = this.$t('releaseStatistics.lastWeek')
        this.startTime = A_WEEK_AGO
        this.endTime = TOMORROW_DAY
        this.getChartData()
      },
      queryLastMonth () {
        this.choosenTime = this.$t('releaseStatistics.lastMonth')
        this.startTime = A_MONTH_AGO
        this.endTime = TOMORROW_DAY
        this.getChartData()
      },
      searchTime () {
        this.choosenTime = `${this.startTime} ${this.$t('common.to')} ${this.endTime}`
        this.getChartData()
      },
      getChartData () {
        releaseStatisticsBiz.get({
          startTime: TimeFormat.formatTimeTolong(this.startTime),
          endTime: TimeFormat.formatTimeTolong(this.endTime)
        }).then(data => {
          this.setChartOpt()
          this.timePopperVis = false
          this.$nextTick(() => {
            this.drawChart(data)
          })
        })
      },
      setChartOpt () {
        this.chartOpt = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            type: 'scroll',
            width: '70%',
            top: '4%',
            data: this.legendList
          }
        }
      },
      drawChart (data) {
        this.chartData = {
          rows: data,
          columns: ['time', 'successCount', 'failCount'],
          formatMap: {
            time: 'TIMELONG'
          },
          labelMap: {
            successCount: this.legendList[0],
            failCount: this.legendList[1]
          },
          colors: ['#0B8DE5', '#EC6F6F'],
          seriesStyle: {
            lineStyle: {
              normal: {
                width: 1.6
              }
            },
            symbol: 'emptyCircle',
            smooth: true
          }
        }
      }
    },
    mounted () {
      const styleObj = {
        height: document.getElementsByClassName('tabView')[0].clientHeight - 130 - 32 + 'px'
      }
      this.chartStyle = { ...styleObj, position: 'relative', width: '100%' }
      this.getAllcount()
      this.getChartData()
    }
  }
</script>

<style scoped>
  .btn-position {
    position: absolute;
    z-index: 99;
    right: 10px;
    top: 10px;
  }
  .release-chart-title {
    font-weight: bolder;
    font-size: 16px;
    position: absolute;
    z-index: 99;
    left: 10px;
    top: 10px;
  }
</style>